module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.displayNextPage) ? _c('button', {
    staticClass: "milkyBlock pagination pull-right paginationNumber",
    on: {
      "click": function($event) {
        return _vm.pagination(_vm.currentPage + 1)
      }
    }
  }, [_c('f7-icon', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "f7": "chevron_right"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.displayNextPage || _vm.displayPreviousPage) ? _c('div', {
    staticClass: "milkyBlock pagination pull-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentPage))])]) : _vm._e(), _vm._v(" "), (_vm.displayPreviousPage) ? _c('button', {
    staticClass: "milkyBlock pagination pull-right paginationNumber",
    on: {
      "click": function($event) {
        return _vm.pagination(_vm.currentPage - 1)
      }
    }
  }, [_c('f7-icon', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "f7": "chevron_left"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30796097", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30796097","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/pagination.vue
// module id = 2322
// module chunks = 2